import { api } from 'src/redux/base-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AddCodeInput = {
  code: Scalars['String'];
};

export type AddPlayerCodeInput = {
  code: Scalars['String'];
};

export type AddTrainerCodeInput = {
  code: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CancelReleasedPlayerScoreInput = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type CancelReleasedPlayerScoreOutput = {
  __typename?: 'CancelReleasedPlayerScoreOutput';
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type Card = {
  cvc: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  number: Scalars['String'];
};

export type CheckEmailExistInput = {
  email: Scalars['String'];
};

export type CheckEmailExistOutput = {
  __typename?: 'CheckEmailExistOutput';
  email: Scalars['String'];
  exist: Scalars['Boolean'];
};

export type CheckEmailTokenInput = {
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type CheckEmailTokenOutput = {
  __typename?: 'CheckEmailTokenOutput';
  sub: Scalars['String'];
  tokenValid: Scalars['Boolean'];
  type: Scalars['String'];
  user: User;
  uuid: Scalars['String'];
};

export type CheckUsernameExistInput = {
  username: Scalars['String'];
};

export type CheckUsernameExistOutput = {
  __typename?: 'CheckUsernameExistOutput';
  exist: Scalars['Boolean'];
  username: Scalars['String'];
};

export type Club = {
  __typename?: 'Club';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
};

export type CompareInput = {
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  sub?: InputMaybe<Scalars['String']>;
  subFrom?: InputMaybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type Comparison = {
  __typename?: 'Comparison';
  compareA: ComparisonScore;
  compareB: ComparisonScore;
  difference: Array<SubScores>;
  playerSessionId?: Maybe<Scalars['Int']>;
  role: UserRole;
  sessionNumber?: Maybe<Scalars['Int']>;
  type: ComparisonType;
};

export type ComparisonOptions = {
  __typename?: 'ComparisonOptions';
  compareFrom?: Maybe<WatchComparisonResult>;
  players: Array<Player>;
  previous?: Maybe<Array<PreviousSession>>;
  team?: Maybe<Club>;
};

export type ComparisonScore = {
  __typename?: 'ComparisonScore';
  avatar?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  subScores: Array<SubScores>;
};

export enum ComparisonSelected {
  Player = 'Player',
  Team = 'Team'
}

export enum ComparisonType {
  Me = 'ME',
  Team = 'TEAM',
  TeamPlayer = 'TEAM_PLAYER',
  Youth = 'YOUTH'
}

export type ConfirmLegalGuardianInput = {
  birthdate: SeparatedDateInput;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  token: Scalars['String'];
};

export type ConfirmLegalGuardianOutput = {
  __typename?: 'ConfirmLegalGuardianOutput';
  confirmed: Scalars['Boolean'];
  user: User;
};

export type ConfirmUserEmailInput = {
  token: Scalars['String'];
};

export type ConfirmUserEmailOutput = {
  __typename?: 'ConfirmUserEmailOutput';
  user: User;
};

export type CreateClubInput = {
  name: Scalars['String'];
};

export type CreateOperatorSessionInput = {
  ageGroup: Scalars['String'];
  clubId: Scalars['Int'];
  fixedGoalkeepers?: InputMaybe<Scalars['Boolean']>;
  geolocation?: InputMaybe<GeoLocation>;
  ground?: InputMaybe<GroundInput>;
  playerCodes: Array<Scalars['String']>;
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  trainerCodes: Array<Scalars['String']>;
};

export type CreateOperatorSessionOutput = {
  __typename?: 'CreateOperatorSessionOutput';
  created: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
};

export type CreateScoutingEventInput = {
  clubId: Scalars['Int'];
  end: Scalars['Date'];
  externalSources?: InputMaybe<Array<Scalars['String']>>;
  fixedGoalKeepers?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  playerIds?: InputMaybe<Array<Scalars['String']>>;
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Date'];
  trainerIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateStripeIntentInput = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type CreateStripeIntentOutput = {
  __typename?: 'CreateStripeIntentOutput';
  clientSecret: Scalars['String'];
  fresh: Scalars['Boolean'];
  pubKey: Scalars['String'];
  stripeId: Scalars['String'];
};

export type DeleteAccountInput = {
  password: Scalars['String'];
};

export type DeleteAccountOutput = {
  __typename?: 'DeleteAccountOutput';
  deleted: Scalars['Boolean'];
  sub: Scalars['String'];
};

export type DeleteOperatorSessionOutput = {
  __typename?: 'DeleteOperatorSessionOutput';
  deleted: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
};

export type EventPlayer = {
  __typename?: 'EventPlayer';
  inSession: Scalars['Boolean'];
  player: User;
};

export type FindComparisonInput = {
  playerSessionId?: InputMaybe<Scalars['Int']>;
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  type: ComparisonType;
};

export type FindComparisonOptionsInput = {
  role: UserRole;
  selected?: InputMaybe<ComparisonSelected>;
  subFrom?: InputMaybe<Scalars['String']>;
};

export type FindVideosOutput = {
  __typename?: 'FindVideosOutput';
  date: Scalars['Date'];
  playerSessionId?: Maybe<Scalars['Int']>;
  sessionNumber: Scalars['Int'];
  videos: Array<VideoTumb>;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
  username: Scalars['String'];
};

export type ForgotPasswordOutput = {
  __typename?: 'ForgotPasswordOutput';
  email: Scalars['String'];
  emailSent: Scalars['Boolean'];
};

export type ForgotUserPasswordInput = {
  usernameOrEmail: Scalars['String'];
};

export type ForgotUserPasswordOutput = {
  __typename?: 'ForgotUserPasswordOutput';
  email: Scalars['String'];
  emailSent: Scalars['Boolean'];
};

export type FoundComparison = {
  __typename?: 'FoundComparison';
  compareFrom?: Maybe<FoundComparisonScore>;
  compareTo?: Maybe<FoundComparisonScore>;
  difference?: Maybe<Array<SubScores>>;
  role: UserRole;
  sessionNumber?: Maybe<Scalars['Int']>;
  sub?: Maybe<Scalars['String']>;
  subFrom?: Maybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type FoundComparisonScore = {
  __typename?: 'FoundComparisonScore';
  avatar?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  sessionNumber: Scalars['Int'];
  subScores?: Maybe<Array<SubScores>>;
};

export enum FoundComparisonType {
  PlayerVsPlayer = 'PlayerVsPlayer',
  PlayerVsPrev = 'PlayerVsPrev',
  PlayerVsTeam = 'PlayerVsTeam',
  SelectedPlayerVsPlayer = 'SelectedPlayerVsPlayer',
  SelectedPlayerVsPrev = 'SelectedPlayerVsPrev',
  SelectedPlayerVsTeam = 'SelectedPlayerVsTeam',
  TeamVsPlayer = 'TeamVsPlayer',
  TeamVsPrev = 'TeamVsPrev'
}

export type GeoLocation = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type GetEmailVerificationTokenInput = {
  email: Scalars['String'];
};

export type GetEmailVerificationTokenOutput = {
  __typename?: 'GetEmailVerificationTokenOutput';
  email: Scalars['String'];
  expiredIn?: Maybe<Scalars['Date']>;
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
};

export type Ground = {
  __typename?: 'Ground';
  goalHeight?: Maybe<Scalars['Float']>;
  goalWidth?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type GroundInput = {
  goalHeight?: InputMaybe<Scalars['Float']>;
  goalWidth?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type ImpersonateInput = {
  email: Scalars['String'];
  sub: Scalars['String'];
};

export type LegalGuardian = {
  __typename?: 'LegalGuardian';
  birthdate?: Maybe<SeparatedDate>;
  consent: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type LegalGuardianInput = {
  birthdate: SeparatedDateInput;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type LegalGuardianSignUpInput = {
  birthdate?: InputMaybe<SeparatedDateInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type LogoutInput = {
  refreshToken: Scalars['String'];
};

export type LogoutOutput = {
  __typename?: 'LogoutOutput';
  logout: Scalars['Boolean'];
  sub: Scalars['String'];
};

export type Match = {
  players: Array<PlayerGoals>;
};

export type Mutation = {
  __typename?: 'Mutation';
  UpdateEventSession: OperatorSession;
  addCode: SessionOrScore;
  addPlayerCode: Score;
  addTrainerCode: Session;
  cancelReleasedPlayerScore: CancelReleasedPlayerScoreOutput;
  confirmLegalGuardian: ConfirmLegalGuardianOutput;
  confirmUserEmail: ConfirmUserEmailOutput;
  createClub: Club;
  createEvent: ScoutingEvent;
  createEventSession: OperatorSession;
  createOperatorSession: CreateOperatorSessionOutput;
  createStripeIntent: CreateStripeIntentOutput;
  createWatchComparison: WatchComparison;
  createWatchSession: WatchSession;
  deleteAccount: DeleteAccountOutput;
  deleteEvent: Scalars['Boolean'];
  deleteEventSession: Scalars['Boolean'];
  deleteOperatorSession: DeleteOperatorSessionOutput;
  deleteUser: Scalars['Boolean'];
  deleteWatchComparison: WatchComparisonDeletedOutput;
  deleteWatchSession: WatchSessionDeletedOutput;
  forgotPassword: ForgotPasswordOutput;
  forgotUserPassword: ForgotUserPasswordOutput;
  impersonate: SignInOutput;
  logout: LogoutOutput;
  payPlayerSessionWithCard: PayPlayerSessionWithCardOutput;
  payPlayerSessionWithPaypal: PayPlayerSessionWithPaypalOutput;
  processOperatorSession: ProcessOperatorSessionOutput;
  refreshToken: RefreshTokenOutput;
  releasePlayerScore: ReleasePlayerScoreOutput;
  resendExpiredLink: ResendExpiredLinkOutput;
  resendLegalGuardianEmail: ResendLegalGuardianEmailOutput;
  resendUserEmail: ResendUserEmailOutput;
  resetPassword: ResetPasswordOutput;
  resetUserPassword: ResetUserPasswordOutput;
  signIn: SignInOutput;
  signUp: SignUpOutput;
  signin: SignInOutput;
  signup: SignUpOutput;
  updateEvent: ScoutingEvent;
  updateOperatorSession: UpdateOperatorSessionOutput;
  updateUser: UpdateUserOutput;
  updateUserAvatar: UpdateUserAvatarOutput;
  updateUserBackground: UpdateUserBackgroundOutput;
  updateUserById: UpdateUserOutput;
  updateUserPassword: UpdateUserPasswordOutput;
  uploadSessionVideo: UploadSessionVideoOutput;
  verifyLegalGuardian: VerifyLegalGuardianOutput;
  verifyUserEmail: VerifyUserEmailOutput;
};


export type MutationUpdateEventSessionArgs = {
  eventNumber: Scalars['Int'];
  session: UpdateOperatorSessionInput;
};


export type MutationAddCodeArgs = {
  addCodeInput: AddCodeInput;
};


export type MutationAddPlayerCodeArgs = {
  addPlayerCodeInput: AddPlayerCodeInput;
};


export type MutationAddTrainerCodeArgs = {
  addTrainerCodeInput: AddTrainerCodeInput;
};


export type MutationCancelReleasedPlayerScoreArgs = {
  cancelReleasedPlayerScoreInput: CancelReleasedPlayerScoreInput;
};


export type MutationConfirmLegalGuardianArgs = {
  confirmLegalGuardianInput: ConfirmLegalGuardianInput;
};


export type MutationConfirmUserEmailArgs = {
  confirmUserEmailInput: ConfirmUserEmailInput;
};


export type MutationCreateClubArgs = {
  createClubInput: CreateClubInput;
};


export type MutationCreateEventArgs = {
  createScoutingEventInput: CreateScoutingEventInput;
};


export type MutationCreateEventSessionArgs = {
  args: CreateOperatorSessionInput;
  eventNumber: Scalars['Int'];
};


export type MutationCreateOperatorSessionArgs = {
  createOperatorSessionInput: CreateOperatorSessionInput;
};


export type MutationCreateStripeIntentArgs = {
  createStripeIntentInput: CreateStripeIntentInput;
};


export type MutationCreateWatchComparisonArgs = {
  createWatchComparisonInput: WatchComparisonInput;
};


export type MutationCreateWatchSessionArgs = {
  createWatchSessionInput: WatchSessionInput;
};


export type MutationDeleteAccountArgs = {
  deleteAccountInput: DeleteAccountInput;
};


export type MutationDeleteEventArgs = {
  eventNumber: Scalars['Int'];
};


export type MutationDeleteEventSessionArgs = {
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type MutationDeleteOperatorSessionArgs = {
  sessionNumber: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationDeleteWatchComparisonArgs = {
  deleteWatchComparisonInput: WatchComparisonInput;
};


export type MutationDeleteWatchSessionArgs = {
  deleteWatchSessionInput: WatchSessionInput;
};


export type MutationForgotPasswordArgs = {
  forgotPasswordInput: ForgotPasswordInput;
};


export type MutationForgotUserPasswordArgs = {
  forgotUserPasswordInput: ForgotUserPasswordInput;
};


export type MutationImpersonateArgs = {
  impersonateInput: ImpersonateInput;
};


export type MutationLogoutArgs = {
  logoutInput: LogoutInput;
};


export type MutationPayPlayerSessionWithCardArgs = {
  payPlayerSessionWithCardInput: PayPlayerSessionWithCardInput;
};


export type MutationPayPlayerSessionWithPaypalArgs = {
  payPlayerSessionWithPaypalInput: PayPlayerSessionWithPaypalInput;
};


export type MutationProcessOperatorSessionArgs = {
  processOperatorSessionInput: ProcessOperatorSessionInput;
};


export type MutationRefreshTokenArgs = {
  refreshTokenInput: RefreshTokenInput;
};


export type MutationReleasePlayerScoreArgs = {
  releasePlayerScoreInput: ReleasePlayerScoreInput;
};


export type MutationResendExpiredLinkArgs = {
  resendExpiredLinkInput: ResendExpiredLinkInput;
};


export type MutationResendLegalGuardianEmailArgs = {
  resendLegalGuardianEmailInput: ResendLegalGuardianEmailInput;
};


export type MutationResendUserEmailArgs = {
  resendUserEmailInput: ResendUserEmailInput;
};


export type MutationResetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};


export type MutationResetUserPasswordArgs = {
  resetUserPasswordInput: ResetUserPasswordInput;
};


export type MutationSignInArgs = {
  signInInput: SignInInput;
};


export type MutationSignUpArgs = {
  signUpInput: SignUpInput;
};


export type MutationSigninArgs = {
  signInInput: SignInInput;
};


export type MutationSignupArgs = {
  signUpInput: SignUpInput;
};


export type MutationUpdateEventArgs = {
  updateScoutingEventInput: UpdateScoutingEventInput;
};


export type MutationUpdateOperatorSessionArgs = {
  updateOperatorSessionInput: UpdateOperatorSessionInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserAvatarArgs = {
  file: Scalars['Upload'];
};


export type MutationUpdateUserBackgroundArgs = {
  file: Scalars['Upload'];
};


export type MutationUpdateUserByIdArgs = {
  updateUserByIdInput: UpdateUserByIdInput;
};


export type MutationUpdateUserPasswordArgs = {
  updateUserPasswordInput: UpdateUserPasswordInput;
};


export type MutationUploadSessionVideoArgs = {
  file: Scalars['Upload'];
  sessionNumber: Scalars['Int'];
  videoType: Scalars['String'];
};


export type MutationVerifyLegalGuardianArgs = {
  verifyLegalGuardianInput: VerifyLegalGuardianInput;
};


export type MutationVerifyUserEmailArgs = {
  verifyUserEmailInput: VerifyUserEmailInput;
};

export enum NotificationKey {
  Button = 'Button',
  ButtonUrl = 'ButtonUrl',
  Icon = 'Icon',
  Link = 'Link',
  Url = 'Url'
}

export enum NotificationType {
  AvatarRequired = 'AvatarRequired',
  BackgroundRecomended = 'BackgroundRecomended',
  EmailRequired = 'EmailRequired',
  LegalGuardianRequired = 'LegalGuardianRequired',
  NoSessionPlayer = 'NoSessionPlayer',
  NoSessionTrainer = 'NoSessionTrainer',
  SelfAssessment = 'SelfAssessment'
}

export type NotificationsOutput = {
  __typename?: 'NotificationsOutput';
  minAppVersion: Scalars['String'];
  notificationList: Array<SystemNotification>;
  unreadCount: Scalars['Int'];
};

export type OperatorSession = {
  __typename?: 'OperatorSession';
  ageGroup: Scalars['String'];
  allVideosUploaded: Scalars['Boolean'];
  club: Club;
  date: Scalars['Date'];
  fixedGoalkeepers: Scalars['Boolean'];
  ground?: Maybe<Ground>;
  matchesCount: Scalars['Int'];
  playersCount: Scalars['Int'];
  processed: Scalars['Boolean'];
  scored: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
  shotTest: Scalars['Boolean'];
  sprintTest: Scalars['Boolean'];
  trainersCount: Scalars['Int'];
  videosUploaded: Array<Scalars['String']>;
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PaginatedUsersInput = {
  order?: InputMaybe<UserOrder>;
  roles?: InputMaybe<Array<UserRole>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
};

export type PaginatedUsersOutput = {
  __typename?: 'PaginatedUsersOutput';
  count: Scalars['Float'];
  result: Array<User>;
  skip: Scalars['Float'];
  take: Scalars['Float'];
};

export type PartialOperatorSession = {
  __typename?: 'PartialOperatorSession';
  ageGroup?: Maybe<Scalars['String']>;
  allVideosUploaded?: Maybe<Scalars['Boolean']>;
  club?: Maybe<Club>;
  date?: Maybe<Scalars['Date']>;
  fixedGoalkeepers?: Maybe<Scalars['Boolean']>;
  ground?: Maybe<Ground>;
  matchesCount?: Maybe<Scalars['Int']>;
  playersCount?: Maybe<Scalars['Int']>;
  processed?: Maybe<Scalars['Boolean']>;
  scored?: Maybe<Scalars['Boolean']>;
  sessionNumber?: Maybe<Scalars['Int']>;
  shotTest?: Maybe<Scalars['Boolean']>;
  sprintTest?: Maybe<Scalars['Boolean']>;
  trainersCount?: Maybe<Scalars['Int']>;
  videosUploaded?: Maybe<Array<Scalars['String']>>;
};

export type PayPlayerSessionWithCardInput = {
  card: Card;
  email: Scalars['String'];
  name: Scalars['String'];
  paymentType?: InputMaybe<Scalars['Int']>;
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PayPlayerSessionWithCardOutput = {
  __typename?: 'PayPlayerSessionWithCardOutput';
  paidAt: Scalars['Date'];
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PayPlayerSessionWithPaypalInput = {
  orderId: Scalars['String'];
  payerID: Scalars['String'];
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PayPlayerSessionWithPaypalOutput = {
  __typename?: 'PayPlayerSessionWithPaypalOutput';
  paidAt: Scalars['Date'];
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  paidAt?: Maybe<Scalars['Date']>;
};

export type Player = {
  __typename?: 'Player';
  avatarUrl?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  playerSessionId: Scalars['Int'];
  released: Scalars['Boolean'];
  score?: Maybe<Scalars['Float']>;
  sessionNumber: Scalars['Int'];
  userId?: Maybe<Scalars['String']>;
};

export type PlayerGoals = {
  goals: Scalars['Int'];
  playerSessionId: Scalars['Int'];
};

export type PreviousSession = {
  __typename?: 'PreviousSession';
  avatar?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  released: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
  value?: Maybe<Scalars['Int']>;
};

export type ProcessOperatorSessionInput = {
  matches?: InputMaybe<Array<Match>>;
  sessionNumber: Scalars['Int'];
};

export type ProcessOperatorSessionOutput = {
  __typename?: 'ProcessOperatorSessionOutput';
  processed: Scalars['Boolean'];
  sessionNumber: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  checkEmailExist: CheckEmailExistOutput;
  checkEmailExists: CheckEmailExistOutput;
  checkEmailToken: CheckEmailTokenOutput;
  checkUserNameExist: CheckUsernameExistOutput;
  clubs: Array<Club>;
  compare?: Maybe<FoundComparison>;
  findComparison?: Maybe<Comparison>;
  findComparisonOptions?: Maybe<ComparisonOptions>;
  findEventPlayer: Array<EventPlayer>;
  findEventTrainer: Array<User>;
  findOperatorSessionById?: Maybe<OperatorSession>;
  findPlayerScore?: Maybe<Score>;
  findPlayerScoresByUserId: Array<Score>;
  findPlayers?: Maybe<Array<Player>>;
  findSession?: Maybe<Session>;
  findSessionsByUserId: Array<Session>;
  findVideo?: Maybe<Video>;
  findVideos: Array<FindVideosOutput>;
  getEmailVerificationToken: GetEmailVerificationTokenOutput;
  getEvent: ScoutingEvent;
  getEventSession: OperatorSession;
  getTrainingVideos: Array<SubScoreTrainingVideos>;
  listEventSessions: Array<OperatorSession>;
  listEvents: Array<ScoutingEvent>;
  notificationKeys: Array<NotificationKey>;
  notificationTypes: Array<NotificationType>;
  notifications: NotificationsOutput;
  operatorSessions: Array<OperatorSession>;
  paginatedUsers: PaginatedUsersOutput;
  playerScores: Array<Score>;
  searchPlayers: Array<User>;
  searchTrainers: Array<User>;
  searchUsers: Array<User>;
  sessions: Array<Session>;
  user: User;
  users: Array<User>;
  validateCode: ValidateCodeOutput;
  validateEmail: ValidateEmailOutput;
  watchComparisons: Array<WatchComparison>;
  watchSessions: Array<WatchSession>;
};


export type QueryCheckEmailExistArgs = {
  input: CheckEmailExistInput;
};


export type QueryCheckEmailExistsArgs = {
  input: CheckEmailExistInput;
};


export type QueryCheckEmailTokenArgs = {
  checkEmailTokenInput: CheckEmailTokenInput;
};


export type QueryCheckUserNameExistArgs = {
  input: CheckUsernameExistInput;
};


export type QueryClubsArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type QueryCompareArgs = {
  compareInput: CompareInput;
};


export type QueryFindComparisonArgs = {
  findComparisonInput: FindComparisonInput;
};


export type QueryFindComparisonOptionsArgs = {
  findComparisonOptionsInput: FindComparisonOptionsInput;
};


export type QueryFindEventPlayerArgs = {
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
};


export type QueryFindEventTrainerArgs = {
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
};


export type QueryFindOperatorSessionByIdArgs = {
  sessionNumber: Scalars['Int'];
};


export type QueryFindPlayerScoreArgs = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type QueryFindPlayerScoresByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryFindPlayersArgs = {
  sessionNumber: Scalars['Int'];
};


export type QueryFindSessionArgs = {
  sessionNumber: Scalars['Int'];
};


export type QueryFindSessionsByUserIdArgs = {
  id: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryFindVideoArgs = {
  id: Scalars['String'];
  playerSessionId?: InputMaybe<Scalars['Int']>;
  sessionNumber: Scalars['Int'];
};


export type QueryFindVideosArgs = {
  role: UserRole;
};


export type QueryGetEmailVerificationTokenArgs = {
  getEmailVerificationTokenInput: GetEmailVerificationTokenInput;
};


export type QueryGetEventArgs = {
  eventNumber: Scalars['Int'];
};


export type QueryGetEventSessionArgs = {
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type QueryGetTrainingVideosArgs = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};


export type QueryListEventSessionsArgs = {
  eventNumber: Scalars['Int'];
};


export type QueryPaginatedUsersArgs = {
  paginatedUsersInput: PaginatedUsersInput;
};


export type QueryPlayerScoresArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchPlayersArgs = {
  externalSource: Scalars['String'];
};


export type QuerySearchTrainersArgs = {
  externalSource: Scalars['String'];
};


export type QuerySearchUsersArgs = {
  externalSource: Scalars['String'];
  roles: Array<Scalars['String']>;
};


export type QuerySessionsArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryValidateCodeArgs = {
  code: Scalars['String'];
};


export type QueryValidateEmailArgs = {
  validateEmailInput: ValidateEmailInput;
};


export type QueryWatchComparisonsArgs = {
  role: UserRole;
};


export type QueryWatchSessionsArgs = {
  role: UserRole;
};

export type RawData = {
  __typename?: 'RawData';
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  stringValue?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String'];
};

export type RefreshTokenOutput = {
  __typename?: 'RefreshTokenOutput';
  accessToken: Scalars['String'];
  refreshed: Scalars['Boolean'];
};

export type ReleasePlayerScoreInput = {
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type ReleasePlayerScoreOutput = {
  __typename?: 'ReleasePlayerScoreOutput';
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type ResendExpiredLinkInput = {
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type ResendExpiredLinkOutput = {
  __typename?: 'ResendExpiredLinkOutput';
  sent: Scalars['Boolean'];
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type ResendLegalGuardianEmailInput = {
  language?: InputMaybe<Scalars['String']>;
  newLegalGuardianEmail?: InputMaybe<Scalars['String']>;
};

export type ResendLegalGuardianEmailOutput = {
  __typename?: 'ResendLegalGuardianEmailOutput';
  emailSent: Scalars['Boolean'];
  legalGuardianEmail: Scalars['String'];
};

export type ResendUserEmailInput = {
  newEmail?: InputMaybe<Scalars['String']>;
};

export type ResendUserEmailOutput = {
  __typename?: 'ResendUserEmailOutput';
  email: Scalars['String'];
  emailSent: Scalars['Boolean'];
};

export type ResetPasswordInput = {
  confirmationPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  tempToken: Scalars['String'];
  username: Scalars['String'];
};

export type ResetPasswordOutput = {
  __typename?: 'ResetPasswordOutput';
  passwordChanged: Scalars['String'];
  username: Scalars['String'];
};

export type ResetUserPasswordInput = {
  password: Scalars['String'];
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type ResetUserPasswordOutput = {
  __typename?: 'ResetUserPasswordOutput';
  reset: Scalars['Boolean'];
  user: User;
};

export type Score = {
  __typename?: 'Score';
  ageGroup: Scalars['Int'];
  ageGroupValue: Scalars['String'];
  badgeLevel: Scalars['Int'];
  club?: Maybe<Club>;
  date: Scalars['Date'];
  payment?: Maybe<PaymentDetails>;
  playerSessionId: Scalars['Int'];
  released: Scalars['Boolean'];
  score: Scalars['Float'];
  sessionNumber: Scalars['Int'];
  subScores: Array<SubScores>;
  trainers?: Maybe<Array<User>>;
  user?: Maybe<User>;
};

export type ScoutingEvent = {
  __typename?: 'ScoutingEvent';
  club: Club;
  end: Scalars['Date'];
  eventNumber: Scalars['Float'];
  externalSources: Array<Scalars['String']>;
  fixedGoalKeepers: Scalars['Boolean'];
  name: Scalars['String'];
  players: Array<User>;
  sessions: Array<PartialOperatorSession>;
  shotTest: Scalars['Boolean'];
  sprintTest: Scalars['Boolean'];
  start: Scalars['Date'];
  trainers: Array<User>;
};

export type SeparatedDate = {
  __typename?: 'SeparatedDate';
  day: Scalars['String'];
  month: Scalars['String'];
  year: Scalars['String'];
};

export type SeparatedDateInput = {
  day: Scalars['String'];
  month: Scalars['String'];
  year: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  ageGroup: Scalars['Int'];
  ageGroupValue: Scalars['String'];
  averages: Array<SubScores>;
  badgeLevel: Scalars['Int'];
  club?: Maybe<Club>;
  date: Scalars['Date'];
  playerCount: Scalars['Int'];
  playerReleased: Scalars['Int'];
  score: Scalars['Float'];
  sessionNumber: Scalars['Int'];
  trainers?: Maybe<Array<User>>;
};

export type SessionOrScore = Score | Session;

export type SignInInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SignInOutput = {
  __typename?: 'SignInOutput';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  user: User;
};

export type SignUpInput = {
  birthdate: SeparatedDateInput;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  legalGuardian?: InputMaybe<LegalGuardianSignUpInput>;
  legalGuardianEmail?: InputMaybe<Scalars['String']>;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  role: UserRole;
  username?: InputMaybe<Scalars['String']>;
};

export type SignUpOutput = {
  __typename?: 'SignUpOutput';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  registered: Scalars['Boolean'];
  user: User;
};

export type SubScorePlayers = {
  __typename?: 'SubScorePlayers';
  avatarUrl?: Maybe<Scalars['String']>;
  playerSessionId: Scalars['Int'];
  sub?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type SubScoreTrainingVideos = {
  __typename?: 'SubScoreTrainingVideos';
  playerSessionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
  trainingsVideos: Array<TrainingsVideo>;
  type: Scalars['String'];
  userId: Scalars['String'];
};

export type SubScores = {
  __typename?: 'SubScores';
  bestPlayers?: Maybe<Array<SubScorePlayers>>;
  counts?: Maybe<Array<Scalars['Int']>>;
  difference?: Maybe<Scalars['Int']>;
  rawData?: Maybe<Array<RawData>>;
  trainingsVideos?: Maybe<Array<TrainingsVideo>>;
  type: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
  worstPlayers?: Maybe<Array<SubScorePlayers>>;
};

export type SystemNotification = {
  __typename?: 'SystemNotification';
  parameters: Array<SystemNotificationParameter>;
  type: Scalars['String'];
};

export type SystemNotificationParameter = {
  __typename?: 'SystemNotificationParameter';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Texts = {
  __typename?: 'Texts';
  subtext: Scalars['String'];
  title: Scalars['String'];
};

export type TrainingsVideo = {
  __typename?: 'TrainingsVideo';
  previewUrl?: Maybe<Scalars['String']>;
  texts?: Maybe<Texts>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type UpdateOperatorSessionInput = {
  ageGroup?: InputMaybe<Scalars['String']>;
  clubId?: InputMaybe<Scalars['Int']>;
  fixedGoalkeepers?: InputMaybe<Scalars['Boolean']>;
  ground?: InputMaybe<GroundInput>;
  sessionNumber: Scalars['Int'];
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  trainerCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateOperatorSessionOutput = {
  __typename?: 'UpdateOperatorSessionOutput';
  sessionNumber: Scalars['Int'];
  updated: Scalars['Boolean'];
};

export type UpdateScoutingEventInput = {
  clubId: Scalars['Float'];
  end?: InputMaybe<Scalars['Date']>;
  eventNumber: Scalars['Float'];
  externalSources?: InputMaybe<Array<Scalars['String']>>;
  fixedGoalKeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  playersIds: Array<Scalars['String']>;
  shotTest?: InputMaybe<Scalars['Boolean']>;
  sprintTest?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Date']>;
  trainerIds: Array<Scalars['String']>;
};

export type UpdateUserAvatarOutput = {
  __typename?: 'UpdateUserAvatarOutput';
  user: User;
};

export type UpdateUserBackgroundOutput = {
  __typename?: 'UpdateUserBackgroundOutput';
  user: User;
};

export type UpdateUserByIdInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  user: User;
};

export type UpdateUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPasswordOutput = {
  __typename?: 'UpdateUserPasswordOutput';
  user: User;
};

export type UploadSessionVideoOutput = {
  __typename?: 'UploadSessionVideoOutput';
  uploaded: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  avatarTimestamp?: Maybe<Scalars['Float']>;
  avatarUrl?: Maybe<Scalars['String']>;
  backgroundTimestamp?: Maybe<Scalars['Float']>;
  backgroundUrl?: Maybe<Scalars['String']>;
  birthdate?: Maybe<SeparatedDate>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  externalSource?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalGuardian?: Maybe<LegalGuardian>;
  name?: Maybe<Scalars['String']>;
  newsletterSubscription: Scalars['Boolean'];
  roles?: Maybe<Array<UserRole>>;
  sub: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type UserOrder = {
  createdTimestamp?: InputMaybe<Order>;
  username?: InputMaybe<Order>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Clubcreator = 'CLUBCREATOR',
  ExternalSource = 'EXTERNAL_SOURCE',
  Operator = 'OPERATOR',
  Player = 'PLAYER',
  ScoutingEventOperator = 'SCOUTING_EVENT_OPERATOR',
  Trainer = 'TRAINER',
  OfflineAccess = 'offline_access',
  PortalUser = 'portal_user',
  UmaAuthorization = 'uma_authorization'
}

export type ValidateCodeOutput = {
  __typename?: 'ValidateCodeOutput';
  code: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type ValidateEmailInput = {
  email: Scalars['String'];
};

export type ValidateEmailOutput = {
  __typename?: 'ValidateEmailOutput';
  email: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type VerifyLegalGuardianInput = {
  legalGuardian: LegalGuardianInput;
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type VerifyLegalGuardianOutput = {
  __typename?: 'VerifyLegalGuardianOutput';
  user: User;
  verified: Scalars['Boolean'];
};

export type VerifyUserEmailInput = {
  sub: Scalars['String'];
  type: Scalars['String'];
  uuid: Scalars['String'];
};

export type VerifyUserEmailOutput = {
  __typename?: 'VerifyUserEmailOutput';
  user: User;
  verified: Scalars['Boolean'];
};

export type Video = {
  __typename?: 'Video';
  cookies: Array<Scalars['String']>;
  id: Scalars['String'];
  url: Scalars['String'];
};

export type VideoTumb = {
  __typename?: 'VideoTumb';
  id: Scalars['String'];
  match: Scalars['String'];
  thumb: Scalars['String'];
};

export type WatchComparison = {
  __typename?: 'WatchComparison';
  compareFrom: WatchComparisonResult;
  compareTo: WatchComparisonResult;
  id: Scalars['String'];
  role: UserRole;
  sessionNumber?: Maybe<Scalars['Int']>;
  skill: Scalars['String'];
  sub?: Maybe<Scalars['String']>;
  subFrom?: Maybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type WatchComparisonDeletedOutput = {
  __typename?: 'WatchComparisonDeletedOutput';
  deleted: Scalars['Boolean'];
};

export type WatchComparisonInput = {
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  skill: Scalars['String'];
  sub?: InputMaybe<Scalars['String']>;
  subFrom?: InputMaybe<Scalars['String']>;
  type: FoundComparisonType;
};

export type WatchComparisonResult = {
  __typename?: 'WatchComparisonResult';
  avatar?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  name?: Maybe<Scalars['String']>;
  sessionNumber: Scalars['Int'];
  value: Scalars['Int'];
};

export type WatchScore = {
  __typename?: 'WatchScore';
  avatar?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

export type WatchSession = {
  __typename?: 'WatchSession';
  id: Scalars['String'];
  playerSessionId?: Maybe<Scalars['Int']>;
  role: UserRole;
  scoreA: WatchScore;
  scoreB: WatchScore;
  sessionNumber?: Maybe<Scalars['Int']>;
  skill: Scalars['String'];
  type: ComparisonType;
};

export type WatchSessionDeletedOutput = {
  __typename?: 'WatchSessionDeletedOutput';
  deleted: Scalars['Boolean'];
};

export type WatchSessionInput = {
  playerSessionId?: InputMaybe<Scalars['Int']>;
  role: UserRole;
  sessionNumber?: InputMaybe<Scalars['Int']>;
  skill: Scalars['String'];
  type: ComparisonType;
};

export type OperatorSessionFragmentFragment = { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null };

export type PartialOperatorSessionFragmentFragment = { __typename?: 'PartialOperatorSession', sessionNumber?: number | null, ageGroup?: string | null, fixedGoalkeepers?: boolean | null, sprintTest?: boolean | null, shotTest?: boolean | null, playersCount?: number | null, trainersCount?: number | null, matchesCount?: number | null, processed?: boolean | null, scored?: boolean | null, date?: any | null, allVideosUploaded?: boolean | null, videosUploaded?: Array<string> | null, club?: { __typename?: 'Club', id?: number | null, name?: string | null } | null, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null };

export type PlayerScoreFragmentFragment = { __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null };

export type TrainerSessionFragmentFragment = { __typename?: 'Session', sessionNumber: number, ageGroup: number, ageGroupValue: string, date: any, score: number, badgeLevel: number, playerCount: number, playerReleased: number, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null, averages: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null, bestPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null, worstPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null }> };

export type UserFragmentFragment = { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null };

export type AddCodeMutationVariables = Exact<{
  input: AddCodeInput;
}>;


export type AddCodeMutation = { __typename?: 'Mutation', addCode: { __typename: 'Score', date: any, playerSessionId: number, sessionNumber: number, user?: { __typename?: 'User', email?: string | null, firstName?: string | null, lastName?: string | null } | null, payment?: { __typename?: 'PaymentDetails', paidAt?: any | null, amount?: number | null, currency?: string | null, id: number } | null } | { __typename: 'Session', sessionNumber: number } };

export type CancelReleasedPlayerScoreMutationVariables = Exact<{
  input: CancelReleasedPlayerScoreInput;
}>;


export type CancelReleasedPlayerScoreMutation = { __typename?: 'Mutation', cancelReleasedPlayerScore: { __typename?: 'CancelReleasedPlayerScoreOutput', playerSessionId: number, sessionNumber: number } };

export type ConfirmLegalGuardianMutationVariables = Exact<{
  input: ConfirmLegalGuardianInput;
}>;


export type ConfirmLegalGuardianMutation = { __typename?: 'Mutation', confirmLegalGuardian: { __typename?: 'ConfirmLegalGuardianOutput', confirmed: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type CreateClubMutationVariables = Exact<{
  input: CreateClubInput;
}>;


export type CreateClubMutation = { __typename?: 'Mutation', createClub: { __typename?: 'Club', id?: number | null, city?: string | null, country?: string | null, logoUrl?: string | null, name?: string | null, street?: string | null } };

export type CreateEventMutationVariables = Exact<{
  input: CreateScoutingEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'ScoutingEvent', name: string, start: any, end: any, fixedGoalKeepers: boolean, sprintTest: boolean, shotTest: boolean, club: { __typename?: 'Club', id?: number | null, name?: string | null } } };

export type CreateEventSessionMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
  args: CreateOperatorSessionInput;
}>;


export type CreateEventSessionMutation = { __typename?: 'Mutation', createEventSession: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, playersCount: number, trainersCount: number, matchesCount: number } };

export type CreateOperatorSessionMutationVariables = Exact<{
  input: CreateOperatorSessionInput;
}>;


export type CreateOperatorSessionMutation = { __typename?: 'Mutation', createOperatorSession: { __typename?: 'CreateOperatorSessionOutput', sessionNumber: number, created: boolean } };

export type CreateStripeIntentMutationVariables = Exact<{
  input: CreateStripeIntentInput;
}>;


export type CreateStripeIntentMutation = { __typename?: 'Mutation', createStripeIntent: { __typename?: 'CreateStripeIntentOutput', stripeId: string, pubKey: string, clientSecret: string, fresh: boolean } };

export type CreateWatchComparisonMutationVariables = Exact<{
  input: WatchComparisonInput;
}>;


export type CreateWatchComparisonMutation = { __typename?: 'Mutation', createWatchComparison: { __typename?: 'WatchComparison', id: string, role: UserRole, skill: string, type: FoundComparisonType, sessionNumber?: number | null, subFrom?: string | null, sub?: string | null, compareFrom: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number }, compareTo: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number } } };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'DeleteAccountOutput', sub: string, deleted: boolean } };

export type DeleteEventMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: boolean };

export type DeleteEventSessionMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
}>;


export type DeleteEventSessionMutation = { __typename?: 'Mutation', deleteEventSession: boolean };

export type DeleteOperatorSessionMutationVariables = Exact<{
  sessionNumber: Scalars['Int'];
}>;


export type DeleteOperatorSessionMutation = { __typename?: 'Mutation', deleteOperatorSession: { __typename?: 'DeleteOperatorSessionOutput', sessionNumber: number, deleted: boolean } };

export type DeleteWatchComparisonMutationVariables = Exact<{
  input: WatchComparisonInput;
}>;


export type DeleteWatchComparisonMutation = { __typename?: 'Mutation', deleteWatchComparison: { __typename?: 'WatchComparisonDeletedOutput', deleted: boolean } };

export type ForgotUserPasswordMutationVariables = Exact<{
  input: ForgotUserPasswordInput;
}>;


export type ForgotUserPasswordMutation = { __typename?: 'Mutation', forgotUserPassword: { __typename?: 'ForgotUserPasswordOutput', email: string, emailSent: boolean } };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutOutput', sub: string, logout: boolean } };

export type PayPlayerSessionWithCardMutationVariables = Exact<{
  input: PayPlayerSessionWithCardInput;
}>;


export type PayPlayerSessionWithCardMutation = { __typename?: 'Mutation', payPlayerSessionWithCard: { __typename?: 'PayPlayerSessionWithCardOutput', playerSessionId: number, sessionNumber: number, paidAt: any } };

export type PayPlayerSessionWithPaypalMutationVariables = Exact<{
  input: PayPlayerSessionWithPaypalInput;
}>;


export type PayPlayerSessionWithPaypalMutation = { __typename?: 'Mutation', payPlayerSessionWithPaypal: { __typename?: 'PayPlayerSessionWithPaypalOutput', playerSessionId: number, sessionNumber: number, paidAt: any } };

export type ProcessOperatorSessionMutationVariables = Exact<{
  input: ProcessOperatorSessionInput;
}>;


export type ProcessOperatorSessionMutation = { __typename?: 'Mutation', processOperatorSession: { __typename?: 'ProcessOperatorSessionOutput', sessionNumber: number, processed: boolean } };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'RefreshTokenOutput', accessToken: string, refreshed: boolean } };

export type ReleasePlayerScoreMutationVariables = Exact<{
  input: ReleasePlayerScoreInput;
}>;


export type ReleasePlayerScoreMutation = { __typename?: 'Mutation', releasePlayerScore: { __typename?: 'ReleasePlayerScoreOutput', playerSessionId: number, sessionNumber: number } };

export type ResendExpiredLinkMutationVariables = Exact<{
  input: ResendExpiredLinkInput;
}>;


export type ResendExpiredLinkMutation = { __typename?: 'Mutation', resendExpiredLink: { __typename?: 'ResendExpiredLinkOutput', type: string, uuid: string, sub: string, sent: boolean } };

export type ResendLegalGuardianEmailMutationVariables = Exact<{
  input: ResendLegalGuardianEmailInput;
}>;


export type ResendLegalGuardianEmailMutation = { __typename?: 'Mutation', resendLegalGuardianEmail: { __typename?: 'ResendLegalGuardianEmailOutput', legalGuardianEmail: string, emailSent: boolean } };

export type ResendUserEmailMutationVariables = Exact<{
  input: ResendUserEmailInput;
}>;


export type ResendUserEmailMutation = { __typename?: 'Mutation', resendUserEmail: { __typename?: 'ResendUserEmailOutput', email: string, emailSent: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordOutput', username: string, passwordChanged: string } };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword: { __typename?: 'ResetUserPasswordOutput', reset: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type SignInMutationVariables = Exact<{
  input: SignInInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'SignInOutput', accessToken: string, refreshToken: string, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'SignUpOutput', registered: boolean, accessToken: string, refreshToken: string, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateScoutingEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'ScoutingEvent', eventNumber: number, name: string, start: any, end: any, fixedGoalKeepers: boolean, shotTest: boolean, sprintTest: boolean, club: { __typename?: 'Club', id?: number | null, name?: string | null } } };

export type UpdateEventSessionMutationVariables = Exact<{
  eventNumber: Scalars['Int'];
  session: UpdateOperatorSessionInput;
}>;


export type UpdateEventSessionMutation = { __typename?: 'Mutation', UpdateEventSession: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, playersCount: number, trainersCount: number, matchesCount: number } };

export type UpdateOperatorSessionMutationVariables = Exact<{
  input: UpdateOperatorSessionInput;
}>;


export type UpdateOperatorSessionMutation = { __typename?: 'Mutation', updateOperatorSession: { __typename?: 'UpdateOperatorSessionOutput', sessionNumber: number, updated: boolean } };

export type UpdateUserAvatarMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UpdateUserAvatarMutation = { __typename?: 'Mutation', updateUserAvatar: { __typename?: 'UpdateUserAvatarOutput', user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type UpdateUserBackgroundMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UpdateUserBackgroundMutation = { __typename?: 'Mutation', updateUserBackground: { __typename?: 'UpdateUserBackgroundOutput', user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'UpdateUserPasswordOutput', user: { __typename?: 'User', email?: string | null } } };

export type VerifyLegalGuardianMutationVariables = Exact<{
  input: VerifyLegalGuardianInput;
}>;


export type VerifyLegalGuardianMutation = { __typename?: 'Mutation', verifyLegalGuardian: { __typename?: 'VerifyLegalGuardianOutput', verified: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type VerifyUserEmailMutationVariables = Exact<{
  input: VerifyUserEmailInput;
}>;


export type VerifyUserEmailMutation = { __typename?: 'Mutation', verifyUserEmail: { __typename?: 'VerifyUserEmailOutput', verified: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type CheckEmailExistQueryVariables = Exact<{
  input: CheckEmailExistInput;
}>;


export type CheckEmailExistQuery = { __typename?: 'Query', checkEmailExist: { __typename?: 'CheckEmailExistOutput', email: string, exist: boolean } };

export type CheckEmailTokenQueryVariables = Exact<{
  input: CheckEmailTokenInput;
}>;


export type CheckEmailTokenQuery = { __typename?: 'Query', checkEmailToken: { __typename?: 'CheckEmailTokenOutput', type: string, uuid: string, sub: string, tokenValid: boolean, user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } } };

export type CheckUserNameExistQueryVariables = Exact<{
  input: CheckUsernameExistInput;
}>;


export type CheckUserNameExistQuery = { __typename?: 'Query', checkUserNameExist: { __typename?: 'CheckUsernameExistOutput', username: string, exist: boolean } };

export type ClubsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type ClubsQuery = { __typename?: 'Query', clubs: Array<{ __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null }> };

export type CompareQueryVariables = Exact<{
  input: CompareInput;
}>;


export type CompareQuery = { __typename?: 'Query', compare?: { __typename?: 'FoundComparison', role: UserRole, type: FoundComparisonType, sessionNumber?: number | null, subFrom?: string | null, sub?: string | null, difference?: Array<{ __typename?: 'SubScores', type: string, value?: number | null }> | null, compareFrom?: { __typename?: 'FoundComparisonScore', name?: string | null, sessionNumber: number, avatar?: string | null, date?: any | null, subScores?: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }> | null } | null, compareTo?: { __typename?: 'FoundComparisonScore', name?: string | null, sessionNumber: number, avatar?: string | null, date?: any | null, subScores?: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }> | null } | null } | null };

export type FindComparisonOptionsQueryVariables = Exact<{
  input: FindComparisonOptionsInput;
}>;


export type FindComparisonOptionsQuery = { __typename?: 'Query', findComparisonOptions?: { __typename?: 'ComparisonOptions', compareFrom?: { __typename?: 'WatchComparisonResult', name?: string | null, avatar?: string | null, date: any, sessionNumber: number, value: number } | null, team?: { __typename?: 'Club', id?: number | null, name?: string | null, logoUrl?: string | null, score?: number | null } | null, players: Array<{ __typename?: 'Player', sessionNumber: number, userId?: string | null, playerSessionId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, released: boolean, score?: number | null }>, previous?: Array<{ __typename?: 'PreviousSession', avatar?: string | null, date: any, sessionNumber: number, value?: number | null, released: boolean }> | null } | null };

export type FindEventPlayerQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
}>;


export type FindEventPlayerQuery = { __typename?: 'Query', findEventPlayer: Array<{ __typename?: 'EventPlayer', inSession: boolean, player: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } }> };

export type FindEventTrainerQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
  search: Scalars['String'];
}>;


export type FindEventTrainerQuery = { __typename?: 'Query', findEventTrainer: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type FindOperatorSessionByIdQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
}>;


export type FindOperatorSessionByIdQuery = { __typename?: 'Query', findOperatorSessionById?: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null } | null };

export type PlayerSessionQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
  playerSessionId: Scalars['Int'];
}>;


export type PlayerSessionQuery = { __typename?: 'Query', findPlayerScore?: { __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null } | null };

export type FindPlayerScoresByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FindPlayerScoresByUserIdQuery = { __typename?: 'Query', findPlayerScoresByUserId: Array<{ __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null }> };

export type FindPlayersQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
}>;


export type FindPlayersQuery = { __typename?: 'Query', findPlayers?: Array<{ __typename?: 'Player', sessionNumber: number, playerSessionId: number, score?: number | null, released: boolean, userId?: string | null, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null }> | null };

export type FindVideoQueryVariables = Exact<{
  id: Scalars['String'];
  sessionNumber: Scalars['Int'];
  playerSessionId?: InputMaybe<Scalars['Int']>;
}>;


export type FindVideoQuery = { __typename?: 'Query', findVideo?: { __typename?: 'Video', id: string, url: string, cookies: Array<string> } | null };

export type FindVideosQueryVariables = Exact<{
  role: UserRole;
}>;


export type FindVideosQuery = { __typename?: 'Query', findVideos: Array<{ __typename?: 'FindVideosOutput', date: any, sessionNumber: number, playerSessionId?: number | null, videos: Array<{ __typename?: 'VideoTumb', id: string, thumb: string, match: string }> }> };

export type GetEventQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
}>;


export type GetEventQuery = { __typename?: 'Query', getEvent: { __typename?: 'ScoutingEvent', eventNumber: number, name: string, start: any, end: any, fixedGoalKeepers: boolean, shotTest: boolean, sprintTest: boolean, externalSources: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, players: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, trainers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, sessions: Array<{ __typename?: 'PartialOperatorSession', sessionNumber?: number | null, ageGroup?: string | null, fixedGoalkeepers?: boolean | null, sprintTest?: boolean | null, shotTest?: boolean | null, playersCount?: number | null, trainersCount?: number | null, matchesCount?: number | null, processed?: boolean | null, scored?: boolean | null, date?: any | null, allVideosUploaded?: boolean | null, videosUploaded?: Array<string> | null, club?: { __typename?: 'Club', id?: number | null, name?: string | null } | null, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null }> } };

export type GetEventSessionQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
  sessionNumber: Scalars['Int'];
}>;


export type GetEventSessionQuery = { __typename?: 'Query', getEventSession: { __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null } };

export type ListEventSessionsQueryVariables = Exact<{
  eventNumber: Scalars['Int'];
}>;


export type ListEventSessionsQuery = { __typename?: 'Query', listEventSessions: Array<{ __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null }> };

export type ListEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListEventsQuery = { __typename?: 'Query', listEvents: Array<{ __typename?: 'ScoutingEvent', eventNumber: number, name: string, start: any, end: any, fixedGoalKeepers: boolean, shotTest: boolean, sprintTest: boolean, externalSources: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, players: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, trainers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }>, sessions: Array<{ __typename?: 'PartialOperatorSession', sessionNumber?: number | null }> }> };

export type GetTrainingVideosQueryVariables = Exact<{
  sessionNumber: Scalars['Int'];
  playerSessionId: Scalars['Int'];
}>;


export type GetTrainingVideosQuery = { __typename?: 'Query', getTrainingVideos: Array<{ __typename?: 'SubScoreTrainingVideos', sessionNumber: number, userId: string, playerSessionId: number, type: string, trainingsVideos: Array<{ __typename?: 'TrainingsVideo', uuid?: string | null, thumbnailUrl?: string | null, previewUrl?: string | null, texts?: { __typename?: 'Texts', title: string, subtext: string } | null }> }> };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsOutput', minAppVersion: string, unreadCount: number, notificationList: Array<{ __typename?: 'SystemNotification', type: string, parameters: Array<{ __typename?: 'SystemNotificationParameter', key: string, value?: string | null }> }> } };

export type OperatorSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorSessionsQuery = { __typename?: 'Query', operatorSessions: Array<{ __typename?: 'OperatorSession', sessionNumber: number, ageGroup: string, fixedGoalkeepers: boolean, sprintTest: boolean, shotTest: boolean, playersCount: number, trainersCount: number, matchesCount: number, processed: boolean, scored: boolean, date: any, allVideosUploaded: boolean, videosUploaded: Array<string>, club: { __typename?: 'Club', id?: number | null, name?: string | null }, ground?: { __typename?: 'Ground', width?: number | null, height?: number | null, goalWidth?: number | null, goalHeight?: number | null } | null }> };

export type PlayerSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSessionsQuery = { __typename?: 'Query', playerScores: Array<{ __typename?: 'Score', playerSessionId: number, sessionNumber: number, score: number, badgeLevel: number, ageGroup: number, ageGroupValue: string, date: any, released: boolean, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, payment?: { __typename?: 'PaymentDetails', id: number, amount?: number | null, currency?: string | null, paidAt?: any | null } | null, user?: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } | null, subScores: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null }>, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null }> };

export type SearchExternalSourcesQueryVariables = Exact<{
  externalSource: Scalars['String'];
  roles: Array<Scalars['String']> | Scalars['String'];
}>;


export type SearchExternalSourcesQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', externalSource?: string | null }> };

export type SearchPlayersQueryVariables = Exact<{
  externalSource: Scalars['String'];
}>;


export type SearchPlayersQuery = { __typename?: 'Query', searchPlayers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type SearchTrainersQueryVariables = Exact<{
  externalSource: Scalars['String'];
}>;


export type SearchTrainersQuery = { __typename?: 'Query', searchTrainers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type SearchUsersQueryVariables = Exact<{
  externalSource: Scalars['String'];
  roles: Array<Scalars['String']> | Scalars['String'];
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> };

export type TrainerSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TrainerSessionsQuery = { __typename?: 'Query', sessions: Array<{ __typename?: 'Session', sessionNumber: number, ageGroup: number, ageGroupValue: string, date: any, score: number, badgeLevel: number, playerCount: number, playerReleased: number, trainers?: Array<{ __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null }> | null, club?: { __typename?: 'Club', id?: number | null, logoUrl?: string | null, city?: string | null, country?: string | null, name?: string | null, street?: string | null } | null, averages: Array<{ __typename?: 'SubScores', type: string, value?: number | null, rawData?: Array<{ __typename?: 'RawData', name: string, unit: string, value?: number | null, stringValue?: string | null }> | null, bestPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null, worstPlayers?: Array<{ __typename?: 'SubScorePlayers', playerSessionId: number, avatarUrl?: string | null, value: number, sub?: string | null }> | null }> }> };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', sub: string, username?: string | null, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, backgroundUrl?: string | null, roles?: Array<UserRole> | null, emailVerified?: boolean | null, newsletterSubscription: boolean, externalSource?: string | null, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null, legalGuardian?: { __typename?: 'LegalGuardian', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, consent: boolean, birthdate?: { __typename?: 'SeparatedDate', day: string, month: string, year: string } | null } | null } };

export type ValidateCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ValidateCodeQuery = { __typename?: 'Query', validateCode: { __typename?: 'ValidateCodeOutput', code: string, valid: boolean } };

export type ValidateEmailQueryVariables = Exact<{
  input: ValidateEmailInput;
}>;


export type ValidateEmailQuery = { __typename?: 'Query', validateEmail: { __typename?: 'ValidateEmailOutput', email: string, valid: boolean } };

export type WatchComparisonsQueryVariables = Exact<{
  role: UserRole;
}>;


export type WatchComparisonsQuery = { __typename?: 'Query', watchComparisons: Array<{ __typename?: 'WatchComparison', id: string, role: UserRole, skill: string, type: FoundComparisonType, sessionNumber?: number | null, subFrom?: string | null, sub?: string | null, compareFrom: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number }, compareTo: { __typename?: 'WatchComparisonResult', name?: string | null, sessionNumber: number, avatar?: string | null, date: any, value: number } }> };

export const OperatorSessionFragmentFragmentDoc = `
    fragment OperatorSessionFragment on OperatorSession {
  sessionNumber
  ageGroup
  club {
    id
    name
  }
  fixedGoalkeepers
  sprintTest
  shotTest
  playersCount
  trainersCount
  matchesCount
  processed
  scored
  date
  allVideosUploaded
  videosUploaded
  ground {
    width
    height
    goalWidth
    goalHeight
  }
}
    `;
export const PartialOperatorSessionFragmentFragmentDoc = `
    fragment PartialOperatorSessionFragment on PartialOperatorSession {
  sessionNumber
  ageGroup
  club {
    id
    name
  }
  fixedGoalkeepers
  sprintTest
  shotTest
  playersCount
  trainersCount
  matchesCount
  processed
  scored
  date
  allVideosUploaded
  videosUploaded
  ground {
    width
    height
    goalWidth
    goalHeight
  }
}
    `;
export const UserFragmentFragmentDoc = `
    fragment UserFragment on User {
  sub
  username
  email
  name
  firstName
  lastName
  birthdate {
    day
    month
    year
  }
  avatarUrl
  backgroundUrl
  roles
  emailVerified
  newsletterSubscription
  externalSource
  legalGuardian {
    email
    firstName
    lastName
    phone
    consent
    birthdate {
      day
      month
      year
    }
  }
}
    `;
export const PlayerScoreFragmentFragmentDoc = `
    fragment PlayerScoreFragment on Score {
  trainers {
    ...UserFragment
  }
  playerSessionId
  sessionNumber
  score
  badgeLevel
  ageGroup
  ageGroupValue
  date
  released
  payment {
    id
    amount
    currency
    paidAt
  }
  user {
    ...UserFragment
  }
  subScores {
    type
    value
    rawData {
      name
      unit
      value
      stringValue
    }
  }
  club {
    id
    logoUrl
    city
    country
    name
    street
  }
}
    ${UserFragmentFragmentDoc}`;
export const TrainerSessionFragmentFragmentDoc = `
    fragment TrainerSessionFragment on Session {
  sessionNumber
  ageGroup
  ageGroupValue
  date
  score
  badgeLevel
  playerCount
  playerReleased
  trainers {
    ...UserFragment
  }
  club {
    id
    logoUrl
    city
    country
    name
    street
  }
  averages {
    type
    value
    rawData {
      name
      unit
      value
      stringValue
    }
    bestPlayers {
      playerSessionId
      avatarUrl
      value
      sub
    }
    worstPlayers {
      playerSessionId
      avatarUrl
      value
      sub
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export const AddCodeDocument = `
    mutation addCode($input: AddCodeInput!) {
  addCode(addCodeInput: $input) {
    __typename
    ... on Session {
      sessionNumber
    }
    ... on Score {
      user {
        email
        firstName
        lastName
      }
      date
      playerSessionId
      payment {
        paidAt
        amount
        currency
        id
      }
      sessionNumber
    }
  }
}
    `;
export const CancelReleasedPlayerScoreDocument = `
    mutation cancelReleasedPlayerScore($input: CancelReleasedPlayerScoreInput!) {
  cancelReleasedPlayerScore(cancelReleasedPlayerScoreInput: $input) {
    playerSessionId
    sessionNumber
  }
}
    `;
export const ConfirmLegalGuardianDocument = `
    mutation confirmLegalGuardian($input: ConfirmLegalGuardianInput!) {
  confirmLegalGuardian(confirmLegalGuardianInput: $input) {
    confirmed
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export const CreateClubDocument = `
    mutation createClub($input: CreateClubInput!) {
  createClub(createClubInput: $input) {
    id
    city
    country
    logoUrl
    name
    street
  }
}
    `;
export const CreateEventDocument = `
    mutation createEvent($input: CreateScoutingEventInput!) {
  createEvent(createScoutingEventInput: $input) {
    name
    start
    end
    fixedGoalKeepers
    sprintTest
    shotTest
    club {
      id
      name
    }
  }
}
    `;
export const CreateEventSessionDocument = `
    mutation createEventSession($eventNumber: Int!, $args: CreateOperatorSessionInput!) {
  createEventSession(eventNumber: $eventNumber, args: $args) {
    sessionNumber
    ageGroup
    fixedGoalkeepers
    playersCount
    trainersCount
    matchesCount
  }
}
    `;
export const CreateOperatorSessionDocument = `
    mutation createOperatorSession($input: CreateOperatorSessionInput!) {
  createOperatorSession(createOperatorSessionInput: $input) {
    sessionNumber
    created
  }
}
    `;
export const CreateStripeIntentDocument = `
    mutation createStripeIntent($input: CreateStripeIntentInput!) {
  createStripeIntent(createStripeIntentInput: $input) {
    stripeId
    pubKey
    clientSecret
    fresh
  }
}
    `;
export const CreateWatchComparisonDocument = `
    mutation createWatchComparison($input: WatchComparisonInput!) {
  createWatchComparison(createWatchComparisonInput: $input) {
    id
    role
    skill
    type
    sessionNumber
    subFrom
    sub
    compareFrom {
      name
      sessionNumber
      avatar
      date
      value
    }
    compareTo {
      name
      sessionNumber
      avatar
      date
      value
    }
  }
}
    `;
export const DeleteAccountDocument = `
    mutation deleteAccount($input: DeleteAccountInput!) {
  deleteAccount(deleteAccountInput: $input) {
    sub
    deleted
  }
}
    `;
export const DeleteEventDocument = `
    mutation deleteEvent($eventNumber: Int!) {
  deleteEvent(eventNumber: $eventNumber)
}
    `;
export const DeleteEventSessionDocument = `
    mutation deleteEventSession($eventNumber: Int!, $sessionNumber: Int!) {
  deleteEventSession(eventNumber: $eventNumber, sessionNumber: $sessionNumber)
}
    `;
export const DeleteOperatorSessionDocument = `
    mutation deleteOperatorSession($sessionNumber: Int!) {
  deleteOperatorSession(sessionNumber: $sessionNumber) {
    sessionNumber
    deleted
  }
}
    `;
export const DeleteWatchComparisonDocument = `
    mutation deleteWatchComparison($input: WatchComparisonInput!) {
  deleteWatchComparison(deleteWatchComparisonInput: $input) {
    deleted
  }
}
    `;
export const ForgotUserPasswordDocument = `
    mutation forgotUserPassword($input: ForgotUserPasswordInput!) {
  forgotUserPassword(forgotUserPasswordInput: $input) {
    email
    emailSent
  }
}
    `;
export const LogoutDocument = `
    mutation logout($input: LogoutInput!) {
  logout(logoutInput: $input) {
    sub
    logout
  }
}
    `;
export const PayPlayerSessionWithCardDocument = `
    mutation payPlayerSessionWithCard($input: PayPlayerSessionWithCardInput!) {
  payPlayerSessionWithCard(payPlayerSessionWithCardInput: $input) {
    playerSessionId
    sessionNumber
    paidAt
  }
}
    `;
export const PayPlayerSessionWithPaypalDocument = `
    mutation payPlayerSessionWithPaypal($input: PayPlayerSessionWithPaypalInput!) {
  payPlayerSessionWithPaypal(payPlayerSessionWithPaypalInput: $input) {
    playerSessionId
    sessionNumber
    paidAt
  }
}
    `;
export const ProcessOperatorSessionDocument = `
    mutation processOperatorSession($input: ProcessOperatorSessionInput!) {
  processOperatorSession(processOperatorSessionInput: $input) {
    sessionNumber
    processed
  }
}
    `;
export const RefreshTokenDocument = `
    mutation refreshToken($input: RefreshTokenInput!) {
  refreshToken(refreshTokenInput: $input) {
    accessToken
    refreshed
  }
}
    `;
export const ReleasePlayerScoreDocument = `
    mutation releasePlayerScore($input: ReleasePlayerScoreInput!) {
  releasePlayerScore(releasePlayerScoreInput: $input) {
    playerSessionId
    sessionNumber
  }
}
    `;
export const ResendExpiredLinkDocument = `
    mutation resendExpiredLink($input: ResendExpiredLinkInput!) {
  resendExpiredLink(resendExpiredLinkInput: $input) {
    type
    uuid
    sub
    sent
  }
}
    `;
export const ResendLegalGuardianEmailDocument = `
    mutation resendLegalGuardianEmail($input: ResendLegalGuardianEmailInput!) {
  resendLegalGuardianEmail(resendLegalGuardianEmailInput: $input) {
    legalGuardianEmail
    emailSent
  }
}
    `;
export const ResendUserEmailDocument = `
    mutation resendUserEmail($input: ResendUserEmailInput!) {
  resendUserEmail(resendUserEmailInput: $input) {
    email
    emailSent
  }
}
    `;
export const ResetPasswordDocument = `
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(resetPasswordInput: $input) {
    username
    passwordChanged
  }
}
    `;
export const ResetUserPasswordDocument = `
    mutation resetUserPassword($input: ResetUserPasswordInput!) {
  resetUserPassword(resetUserPasswordInput: $input) {
    user {
      ...UserFragment
    }
    reset
  }
}
    ${UserFragmentFragmentDoc}`;
export const SignInDocument = `
    mutation signIn($input: SignInInput!) {
  signIn(signInInput: $input) {
    accessToken
    refreshToken
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export const SignUpDocument = `
    mutation signUp($input: SignUpInput!) {
  signUp(signUpInput: $input) {
    registered
    user {
      ...UserFragment
    }
    accessToken
    refreshToken
  }
}
    ${UserFragmentFragmentDoc}`;
export const UpdateEventDocument = `
    mutation updateEvent($input: UpdateScoutingEventInput!) {
  updateEvent(updateScoutingEventInput: $input) {
    eventNumber
    name
    club {
      id
      name
    }
    start
    end
    fixedGoalKeepers
    shotTest
    sprintTest
  }
}
    `;
export const UpdateEventSessionDocument = `
    mutation updateEventSession($eventNumber: Int!, $session: UpdateOperatorSessionInput!) {
  UpdateEventSession(eventNumber: $eventNumber, session: $session) {
    sessionNumber
    ageGroup
    fixedGoalkeepers
    playersCount
    trainersCount
    matchesCount
  }
}
    `;
export const UpdateOperatorSessionDocument = `
    mutation updateOperatorSession($input: UpdateOperatorSessionInput!) {
  updateOperatorSession(updateOperatorSessionInput: $input) {
    sessionNumber
    updated
  }
}
    `;
export const UpdateUserAvatarDocument = `
    mutation updateUserAvatar($file: Upload!) {
  updateUserAvatar(file: $file) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export const UpdateUserBackgroundDocument = `
    mutation updateUserBackground($file: Upload!) {
  updateUserBackground(file: $file) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export const UpdateUserPasswordDocument = `
    mutation updateUserPassword($input: UpdateUserPasswordInput!) {
  updateUserPassword(updateUserPasswordInput: $input) {
    user {
      email
    }
  }
}
    `;
export const VerifyLegalGuardianDocument = `
    mutation verifyLegalGuardian($input: VerifyLegalGuardianInput!) {
  verifyLegalGuardian(verifyLegalGuardianInput: $input) {
    user {
      ...UserFragment
    }
    verified
  }
}
    ${UserFragmentFragmentDoc}`;
export const VerifyUserEmailDocument = `
    mutation verifyUserEmail($input: VerifyUserEmailInput!) {
  verifyUserEmail(verifyUserEmailInput: $input) {
    user {
      ...UserFragment
    }
    verified
  }
}
    ${UserFragmentFragmentDoc}`;
export const CheckEmailExistDocument = `
    query checkEmailExist($input: CheckEmailExistInput!) {
  checkEmailExist(input: $input) {
    email
    exist
  }
}
    `;
export const CheckEmailTokenDocument = `
    query checkEmailToken($input: CheckEmailTokenInput!) {
  checkEmailToken(checkEmailTokenInput: $input) {
    user {
      ...UserFragment
    }
    type
    uuid
    sub
    tokenValid
  }
}
    ${UserFragmentFragmentDoc}`;
export const CheckUserNameExistDocument = `
    query checkUserNameExist($input: CheckUsernameExistInput!) {
  checkUserNameExist(input: $input) {
    username
    exist
  }
}
    `;
export const ClubsDocument = `
    query clubs($name: String) {
  clubs(name: $name) {
    id
    logoUrl
    city
    country
    name
    street
  }
}
    `;
export const CompareDocument = `
    query compare($input: CompareInput!) {
  compare(compareInput: $input) {
    role
    type
    sessionNumber
    subFrom
    sub
    difference {
      type
      value
    }
    compareFrom {
      name
      sessionNumber
      avatar
      date
      subScores {
        type
        value
        rawData {
          name
          unit
          value
          stringValue
        }
      }
    }
    compareTo {
      name
      sessionNumber
      avatar
      date
      subScores {
        type
        value
        rawData {
          name
          unit
          value
          stringValue
        }
      }
    }
  }
}
    `;
export const FindComparisonOptionsDocument = `
    query findComparisonOptions($input: FindComparisonOptionsInput!) {
  findComparisonOptions(findComparisonOptionsInput: $input) {
    compareFrom {
      name
      avatar
      date
      sessionNumber
      value
    }
    team {
      id
      name
      logoUrl
      score
    }
    players {
      sessionNumber
      userId
      playerSessionId
      avatarUrl
      firstName
      lastName
      released
      score
    }
    previous {
      avatar
      date
      sessionNumber
      value
      released
    }
  }
}
    `;
export const FindEventPlayerDocument = `
    query findEventPlayer($eventNumber: Int!, $search: String!) {
  findEventPlayer(eventNumber: $eventNumber, search: $search) {
    player {
      ...UserFragment
    }
    inSession
  }
}
    ${UserFragmentFragmentDoc}`;
export const FindEventTrainerDocument = `
    query findEventTrainer($eventNumber: Int!, $search: String!) {
  findEventTrainer(eventNumber: $eventNumber, search: $search) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const FindOperatorSessionByIdDocument = `
    query findOperatorSessionById($sessionNumber: Int!) {
  findOperatorSessionById(sessionNumber: $sessionNumber) {
    sessionNumber
    ageGroup
    club {
      id
      name
    }
    fixedGoalkeepers
    sprintTest
    shotTest
    playersCount
    trainersCount
    matchesCount
    processed
    scored
    date
    ground {
      width
      height
      goalWidth
      goalHeight
    }
  }
}
    `;
export const PlayerSessionDocument = `
    query playerSession($sessionNumber: Int!, $playerSessionId: Int!) {
  findPlayerScore(
    sessionNumber: $sessionNumber
    playerSessionId: $playerSessionId
  ) {
    ...PlayerScoreFragment
  }
}
    ${PlayerScoreFragmentFragmentDoc}`;
export const FindPlayerScoresByUserIdDocument = `
    query findPlayerScoresByUserId($userId: String!) {
  findPlayerScoresByUserId(userId: $userId) {
    ...PlayerScoreFragment
  }
}
    ${PlayerScoreFragmentFragmentDoc}`;
export const FindPlayersDocument = `
    query findPlayers($sessionNumber: Int!) {
  findPlayers(sessionNumber: $sessionNumber) {
    sessionNumber
    playerSessionId
    score
    released
    userId
    avatarUrl
    firstName
    lastName
  }
}
    `;
export const FindVideoDocument = `
    query findVideo($id: String!, $sessionNumber: Int!, $playerSessionId: Int) {
  findVideo(
    id: $id
    sessionNumber: $sessionNumber
    playerSessionId: $playerSessionId
  ) {
    id
    url
    cookies
  }
}
    `;
export const FindVideosDocument = `
    query findVideos($role: UserRole!) {
  findVideos(role: $role) {
    date
    sessionNumber
    playerSessionId
    videos {
      id
      thumb
      match
    }
  }
}
    `;
export const GetEventDocument = `
    query getEvent($eventNumber: Int!) {
  getEvent(eventNumber: $eventNumber) {
    eventNumber
    name
    club {
      id
      name
    }
    players {
      ...UserFragment
    }
    trainers {
      ...UserFragment
    }
    sessions {
      ...PartialOperatorSessionFragment
    }
    start
    end
    fixedGoalKeepers
    shotTest
    sprintTest
    externalSources
  }
}
    ${UserFragmentFragmentDoc}
${PartialOperatorSessionFragmentFragmentDoc}`;
export const GetEventSessionDocument = `
    query getEventSession($eventNumber: Int!, $sessionNumber: Int!) {
  getEventSession(eventNumber: $eventNumber, sessionNumber: $sessionNumber) {
    ...OperatorSessionFragment
  }
}
    ${OperatorSessionFragmentFragmentDoc}`;
export const ListEventSessionsDocument = `
    query listEventSessions($eventNumber: Int!) {
  listEventSessions(eventNumber: $eventNumber) {
    ...OperatorSessionFragment
  }
}
    ${OperatorSessionFragmentFragmentDoc}`;
export const ListEventsDocument = `
    query listEvents {
  listEvents {
    eventNumber
    name
    club {
      id
      name
    }
    players {
      ...UserFragment
    }
    trainers {
      ...UserFragment
    }
    sessions {
      sessionNumber
    }
    start
    end
    fixedGoalKeepers
    shotTest
    sprintTest
    externalSources
  }
}
    ${UserFragmentFragmentDoc}`;
export const GetTrainingVideosDocument = `
    query getTrainingVideos($sessionNumber: Int!, $playerSessionId: Int!) {
  getTrainingVideos(
    sessionNumber: $sessionNumber
    playerSessionId: $playerSessionId
  ) {
    sessionNumber
    userId
    playerSessionId
    sessionNumber
    type
    trainingsVideos {
      texts {
        title
        subtext
      }
      uuid
      thumbnailUrl
      previewUrl
    }
  }
}
    `;
export const NotificationsDocument = `
    query notifications {
  notifications {
    minAppVersion
    unreadCount
    notificationList {
      type
      parameters {
        key
        value
      }
    }
  }
}
    `;
export const OperatorSessionsDocument = `
    query operatorSessions {
  operatorSessions {
    sessionNumber
    ageGroup
    club {
      id
      name
    }
    fixedGoalkeepers
    sprintTest
    shotTest
    playersCount
    trainersCount
    matchesCount
    processed
    scored
    date
    allVideosUploaded
    videosUploaded
    ground {
      width
      height
      goalWidth
      goalHeight
    }
  }
}
    `;
export const PlayerSessionsDocument = `
    query playerSessions {
  playerScores {
    ...PlayerScoreFragment
  }
}
    ${PlayerScoreFragmentFragmentDoc}`;
export const SearchExternalSourcesDocument = `
    query searchExternalSources($externalSource: String!, $roles: [String!]!) {
  searchUsers(externalSource: $externalSource, roles: $roles) {
    externalSource
  }
}
    `;
export const SearchPlayersDocument = `
    query searchPlayers($externalSource: String!) {
  searchPlayers(externalSource: $externalSource) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const SearchTrainersDocument = `
    query searchTrainers($externalSource: String!) {
  searchTrainers(externalSource: $externalSource) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const SearchUsersDocument = `
    query searchUsers($externalSource: String!, $roles: [String!]!) {
  searchUsers(externalSource: $externalSource, roles: $roles) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const TrainerSessionsDocument = `
    query trainerSessions {
  sessions {
    ...TrainerSessionFragment
  }
}
    ${TrainerSessionFragmentFragmentDoc}`;
export const UserDocument = `
    query user {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const ValidateCodeDocument = `
    query validateCode($code: String!) {
  validateCode(code: $code) {
    code
    valid
  }
}
    `;
export const ValidateEmailDocument = `
    query validateEmail($input: ValidateEmailInput!) {
  validateEmail(validateEmailInput: $input) {
    email
    valid
  }
}
    `;
export const WatchComparisonsDocument = `
    query watchComparisons($role: UserRole!) {
  watchComparisons(role: $role) {
    id
    role
    skill
    type
    sessionNumber
    subFrom
    sub
    compareFrom {
      name
      sessionNumber
      avatar
      date
      value
    }
    compareTo {
      name
      sessionNumber
      avatar
      date
      value
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    addCode: build.mutation<AddCodeMutation, AddCodeMutationVariables>({
      query: (variables) => ({ document: AddCodeDocument, variables })
    }),
    cancelReleasedPlayerScore: build.mutation<CancelReleasedPlayerScoreMutation, CancelReleasedPlayerScoreMutationVariables>({
      query: (variables) => ({ document: CancelReleasedPlayerScoreDocument, variables })
    }),
    confirmLegalGuardian: build.mutation<ConfirmLegalGuardianMutation, ConfirmLegalGuardianMutationVariables>({
      query: (variables) => ({ document: ConfirmLegalGuardianDocument, variables })
    }),
    createClub: build.mutation<CreateClubMutation, CreateClubMutationVariables>({
      query: (variables) => ({ document: CreateClubDocument, variables })
    }),
    createEvent: build.mutation<CreateEventMutation, CreateEventMutationVariables>({
      query: (variables) => ({ document: CreateEventDocument, variables })
    }),
    createEventSession: build.mutation<CreateEventSessionMutation, CreateEventSessionMutationVariables>({
      query: (variables) => ({ document: CreateEventSessionDocument, variables })
    }),
    createOperatorSession: build.mutation<CreateOperatorSessionMutation, CreateOperatorSessionMutationVariables>({
      query: (variables) => ({ document: CreateOperatorSessionDocument, variables })
    }),
    createStripeIntent: build.mutation<CreateStripeIntentMutation, CreateStripeIntentMutationVariables>({
      query: (variables) => ({ document: CreateStripeIntentDocument, variables })
    }),
    createWatchComparison: build.mutation<CreateWatchComparisonMutation, CreateWatchComparisonMutationVariables>({
      query: (variables) => ({ document: CreateWatchComparisonDocument, variables })
    }),
    deleteAccount: build.mutation<DeleteAccountMutation, DeleteAccountMutationVariables>({
      query: (variables) => ({ document: DeleteAccountDocument, variables })
    }),
    deleteEvent: build.mutation<DeleteEventMutation, DeleteEventMutationVariables>({
      query: (variables) => ({ document: DeleteEventDocument, variables })
    }),
    deleteEventSession: build.mutation<DeleteEventSessionMutation, DeleteEventSessionMutationVariables>({
      query: (variables) => ({ document: DeleteEventSessionDocument, variables })
    }),
    deleteOperatorSession: build.mutation<DeleteOperatorSessionMutation, DeleteOperatorSessionMutationVariables>({
      query: (variables) => ({ document: DeleteOperatorSessionDocument, variables })
    }),
    deleteWatchComparison: build.mutation<DeleteWatchComparisonMutation, DeleteWatchComparisonMutationVariables>({
      query: (variables) => ({ document: DeleteWatchComparisonDocument, variables })
    }),
    forgotUserPassword: build.mutation<ForgotUserPasswordMutation, ForgotUserPasswordMutationVariables>({
      query: (variables) => ({ document: ForgotUserPasswordDocument, variables })
    }),
    logout: build.mutation<LogoutMutation, LogoutMutationVariables>({
      query: (variables) => ({ document: LogoutDocument, variables })
    }),
    payPlayerSessionWithCard: build.mutation<PayPlayerSessionWithCardMutation, PayPlayerSessionWithCardMutationVariables>({
      query: (variables) => ({ document: PayPlayerSessionWithCardDocument, variables })
    }),
    payPlayerSessionWithPaypal: build.mutation<PayPlayerSessionWithPaypalMutation, PayPlayerSessionWithPaypalMutationVariables>({
      query: (variables) => ({ document: PayPlayerSessionWithPaypalDocument, variables })
    }),
    processOperatorSession: build.mutation<ProcessOperatorSessionMutation, ProcessOperatorSessionMutationVariables>({
      query: (variables) => ({ document: ProcessOperatorSessionDocument, variables })
    }),
    refreshToken: build.mutation<RefreshTokenMutation, RefreshTokenMutationVariables>({
      query: (variables) => ({ document: RefreshTokenDocument, variables })
    }),
    releasePlayerScore: build.mutation<ReleasePlayerScoreMutation, ReleasePlayerScoreMutationVariables>({
      query: (variables) => ({ document: ReleasePlayerScoreDocument, variables })
    }),
    resendExpiredLink: build.mutation<ResendExpiredLinkMutation, ResendExpiredLinkMutationVariables>({
      query: (variables) => ({ document: ResendExpiredLinkDocument, variables })
    }),
    resendLegalGuardianEmail: build.mutation<ResendLegalGuardianEmailMutation, ResendLegalGuardianEmailMutationVariables>({
      query: (variables) => ({ document: ResendLegalGuardianEmailDocument, variables })
    }),
    resendUserEmail: build.mutation<ResendUserEmailMutation, ResendUserEmailMutationVariables>({
      query: (variables) => ({ document: ResendUserEmailDocument, variables })
    }),
    resetPassword: build.mutation<ResetPasswordMutation, ResetPasswordMutationVariables>({
      query: (variables) => ({ document: ResetPasswordDocument, variables })
    }),
    resetUserPassword: build.mutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>({
      query: (variables) => ({ document: ResetUserPasswordDocument, variables })
    }),
    signIn: build.mutation<SignInMutation, SignInMutationVariables>({
      query: (variables) => ({ document: SignInDocument, variables })
    }),
    signUp: build.mutation<SignUpMutation, SignUpMutationVariables>({
      query: (variables) => ({ document: SignUpDocument, variables })
    }),
    updateEvent: build.mutation<UpdateEventMutation, UpdateEventMutationVariables>({
      query: (variables) => ({ document: UpdateEventDocument, variables })
    }),
    updateEventSession: build.mutation<UpdateEventSessionMutation, UpdateEventSessionMutationVariables>({
      query: (variables) => ({ document: UpdateEventSessionDocument, variables })
    }),
    updateOperatorSession: build.mutation<UpdateOperatorSessionMutation, UpdateOperatorSessionMutationVariables>({
      query: (variables) => ({ document: UpdateOperatorSessionDocument, variables })
    }),
    updateUserAvatar: build.mutation<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>({
      query: (variables) => ({ document: UpdateUserAvatarDocument, variables })
    }),
    updateUserBackground: build.mutation<UpdateUserBackgroundMutation, UpdateUserBackgroundMutationVariables>({
      query: (variables) => ({ document: UpdateUserBackgroundDocument, variables })
    }),
    updateUserPassword: build.mutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>({
      query: (variables) => ({ document: UpdateUserPasswordDocument, variables })
    }),
    verifyLegalGuardian: build.mutation<VerifyLegalGuardianMutation, VerifyLegalGuardianMutationVariables>({
      query: (variables) => ({ document: VerifyLegalGuardianDocument, variables })
    }),
    verifyUserEmail: build.mutation<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>({
      query: (variables) => ({ document: VerifyUserEmailDocument, variables })
    }),
    checkEmailExist: build.query<CheckEmailExistQuery, CheckEmailExistQueryVariables>({
      query: (variables) => ({ document: CheckEmailExistDocument, variables })
    }),
    checkEmailToken: build.query<CheckEmailTokenQuery, CheckEmailTokenQueryVariables>({
      query: (variables) => ({ document: CheckEmailTokenDocument, variables })
    }),
    checkUserNameExist: build.query<CheckUserNameExistQuery, CheckUserNameExistQueryVariables>({
      query: (variables) => ({ document: CheckUserNameExistDocument, variables })
    }),
    clubs: build.query<ClubsQuery, ClubsQueryVariables | void>({
      query: (variables) => ({ document: ClubsDocument, variables })
    }),
    compare: build.query<CompareQuery, CompareQueryVariables>({
      query: (variables) => ({ document: CompareDocument, variables })
    }),
    findComparisonOptions: build.query<FindComparisonOptionsQuery, FindComparisonOptionsQueryVariables>({
      query: (variables) => ({ document: FindComparisonOptionsDocument, variables })
    }),
    findEventPlayer: build.query<FindEventPlayerQuery, FindEventPlayerQueryVariables>({
      query: (variables) => ({ document: FindEventPlayerDocument, variables })
    }),
    findEventTrainer: build.query<FindEventTrainerQuery, FindEventTrainerQueryVariables>({
      query: (variables) => ({ document: FindEventTrainerDocument, variables })
    }),
    findOperatorSessionById: build.query<FindOperatorSessionByIdQuery, FindOperatorSessionByIdQueryVariables>({
      query: (variables) => ({ document: FindOperatorSessionByIdDocument, variables })
    }),
    playerSession: build.query<PlayerSessionQuery, PlayerSessionQueryVariables>({
      query: (variables) => ({ document: PlayerSessionDocument, variables })
    }),
    findPlayerScoresByUserId: build.query<FindPlayerScoresByUserIdQuery, FindPlayerScoresByUserIdQueryVariables>({
      query: (variables) => ({ document: FindPlayerScoresByUserIdDocument, variables })
    }),
    findPlayers: build.query<FindPlayersQuery, FindPlayersQueryVariables>({
      query: (variables) => ({ document: FindPlayersDocument, variables })
    }),
    findVideo: build.query<FindVideoQuery, FindVideoQueryVariables>({
      query: (variables) => ({ document: FindVideoDocument, variables })
    }),
    findVideos: build.query<FindVideosQuery, FindVideosQueryVariables>({
      query: (variables) => ({ document: FindVideosDocument, variables })
    }),
    getEvent: build.query<GetEventQuery, GetEventQueryVariables>({
      query: (variables) => ({ document: GetEventDocument, variables })
    }),
    getEventSession: build.query<GetEventSessionQuery, GetEventSessionQueryVariables>({
      query: (variables) => ({ document: GetEventSessionDocument, variables })
    }),
    listEventSessions: build.query<ListEventSessionsQuery, ListEventSessionsQueryVariables>({
      query: (variables) => ({ document: ListEventSessionsDocument, variables })
    }),
    listEvents: build.query<ListEventsQuery, ListEventsQueryVariables | void>({
      query: (variables) => ({ document: ListEventsDocument, variables })
    }),
    getTrainingVideos: build.query<GetTrainingVideosQuery, GetTrainingVideosQueryVariables>({
      query: (variables) => ({ document: GetTrainingVideosDocument, variables })
    }),
    notifications: build.query<NotificationsQuery, NotificationsQueryVariables | void>({
      query: (variables) => ({ document: NotificationsDocument, variables })
    }),
    operatorSessions: build.query<OperatorSessionsQuery, OperatorSessionsQueryVariables | void>({
      query: (variables) => ({ document: OperatorSessionsDocument, variables })
    }),
    playerSessions: build.query<PlayerSessionsQuery, PlayerSessionsQueryVariables | void>({
      query: (variables) => ({ document: PlayerSessionsDocument, variables })
    }),
    searchExternalSources: build.query<SearchExternalSourcesQuery, SearchExternalSourcesQueryVariables>({
      query: (variables) => ({ document: SearchExternalSourcesDocument, variables })
    }),
    searchPlayers: build.query<SearchPlayersQuery, SearchPlayersQueryVariables>({
      query: (variables) => ({ document: SearchPlayersDocument, variables })
    }),
    searchTrainers: build.query<SearchTrainersQuery, SearchTrainersQueryVariables>({
      query: (variables) => ({ document: SearchTrainersDocument, variables })
    }),
    searchUsers: build.query<SearchUsersQuery, SearchUsersQueryVariables>({
      query: (variables) => ({ document: SearchUsersDocument, variables })
    }),
    trainerSessions: build.query<TrainerSessionsQuery, TrainerSessionsQueryVariables | void>({
      query: (variables) => ({ document: TrainerSessionsDocument, variables })
    }),
    user: build.query<UserQuery, UserQueryVariables | void>({
      query: (variables) => ({ document: UserDocument, variables })
    }),
    validateCode: build.query<ValidateCodeQuery, ValidateCodeQueryVariables>({
      query: (variables) => ({ document: ValidateCodeDocument, variables })
    }),
    validateEmail: build.query<ValidateEmailQuery, ValidateEmailQueryVariables>({
      query: (variables) => ({ document: ValidateEmailDocument, variables })
    }),
    watchComparisons: build.query<WatchComparisonsQuery, WatchComparisonsQueryVariables>({
      query: (variables) => ({ document: WatchComparisonsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useAddCodeMutation, useCancelReleasedPlayerScoreMutation, useConfirmLegalGuardianMutation, useCreateClubMutation, useCreateEventMutation, useCreateEventSessionMutation, useCreateOperatorSessionMutation, useCreateStripeIntentMutation, useCreateWatchComparisonMutation, useDeleteAccountMutation, useDeleteEventMutation, useDeleteEventSessionMutation, useDeleteOperatorSessionMutation, useDeleteWatchComparisonMutation, useForgotUserPasswordMutation, useLogoutMutation, usePayPlayerSessionWithCardMutation, usePayPlayerSessionWithPaypalMutation, useProcessOperatorSessionMutation, useRefreshTokenMutation, useReleasePlayerScoreMutation, useResendExpiredLinkMutation, useResendLegalGuardianEmailMutation, useResendUserEmailMutation, useResetPasswordMutation, useResetUserPasswordMutation, useSignInMutation, useSignUpMutation, useUpdateEventMutation, useUpdateEventSessionMutation, useUpdateOperatorSessionMutation, useUpdateUserAvatarMutation, useUpdateUserBackgroundMutation, useUpdateUserPasswordMutation, useVerifyLegalGuardianMutation, useVerifyUserEmailMutation, useCheckEmailExistQuery, useLazyCheckEmailExistQuery, useCheckEmailTokenQuery, useLazyCheckEmailTokenQuery, useCheckUserNameExistQuery, useLazyCheckUserNameExistQuery, useClubsQuery, useLazyClubsQuery, useCompareQuery, useLazyCompareQuery, useFindComparisonOptionsQuery, useLazyFindComparisonOptionsQuery, useFindEventPlayerQuery, useLazyFindEventPlayerQuery, useFindEventTrainerQuery, useLazyFindEventTrainerQuery, useFindOperatorSessionByIdQuery, useLazyFindOperatorSessionByIdQuery, usePlayerSessionQuery, useLazyPlayerSessionQuery, useFindPlayerScoresByUserIdQuery, useLazyFindPlayerScoresByUserIdQuery, useFindPlayersQuery, useLazyFindPlayersQuery, useFindVideoQuery, useLazyFindVideoQuery, useFindVideosQuery, useLazyFindVideosQuery, useGetEventQuery, useLazyGetEventQuery, useGetEventSessionQuery, useLazyGetEventSessionQuery, useListEventSessionsQuery, useLazyListEventSessionsQuery, useListEventsQuery, useLazyListEventsQuery, useGetTrainingVideosQuery, useLazyGetTrainingVideosQuery, useNotificationsQuery, useLazyNotificationsQuery, useOperatorSessionsQuery, useLazyOperatorSessionsQuery, usePlayerSessionsQuery, useLazyPlayerSessionsQuery, useSearchExternalSourcesQuery, useLazySearchExternalSourcesQuery, useSearchPlayersQuery, useLazySearchPlayersQuery, useSearchTrainersQuery, useLazySearchTrainersQuery, useSearchUsersQuery, useLazySearchUsersQuery, useTrainerSessionsQuery, useLazyTrainerSessionsQuery, useUserQuery, useLazyUserQuery, useValidateCodeQuery, useLazyValidateCodeQuery, useValidateEmailQuery, useLazyValidateEmailQuery, useWatchComparisonsQuery, useLazyWatchComparisonsQuery } = injectedRtkApi;

